// @flow

import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';

/**
 * Listens for changes in the full screen state to send analytics.
 */
StateListenerRegistry.register(
    /* selector */ state => state['features/toolbox'].visible,
    /* listener */ isVisible => {
        const elBodyClassList = document.body.classList;

        isVisible ? elBodyClassList.remove('elements_hidden') : elBodyClassList.add('elements_hidden');
    }
);
